(function () {
  'use strict';

  if (window.__awknSealSubscriptionsLoaded) return;
  window.__awknSealSubscriptionsLoaded = true;

  var CONFIG = window.AWKNSealSubscriptionsConfig || {};
  var PRODUCT_SETS = {
    test: {
      'night-owl-10x-recovery-shots-best-hangover-cure-new-widget-design': { servings: 10, gift: false },
      'night-owl-30x-recovery-shots-best-hangover-cure-new-widget-design': { servings: 30, gift: true }
    },
    live: {
      'night-owl-alcohol-recovery-10-shots': { servings: 10, gift: false },
      'night-owl-alcohol-recovery-30-shots': { servings: 30, gift: true }
    }
  };
  var MODE = CONFIG.mode === 'live' ? 'live' : 'test';
  var PRODUCTS = PRODUCT_SETS[MODE];
  var productCache = new WeakMap();
  var scheduled = false;

  function parseProduct(target) {
    if (productCache.has(target)) return productCache.get(target);

    var product = null;
    try {
      product = JSON.parse(target.getAttribute('data-product') || 'null');
    } catch (error) {
      console.warn('[AWKN Seal] Could not read Seal product data.', error);
    }

    productCache.set(target, product);
    return product;
  }

  function sameId(left, right) {
    return String(left) === String(right);
  }

  function selectedPlanId(target) {
    var select = target.querySelector('.sls-select[name="subs_interval"]');
    var hidden = target.querySelector('[data-sls-selling_plan]');
    return (select && select.value) || (hidden && hidden.value) || '';
  }

  function selectedVariant(target, product, planId) {
    if (!product || !Array.isArray(product.variants)) return null;

    var form = target.closest('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('[name="id"]');
    var variantId = variantInput && variantInput.value;
    var variant = product.variants.find(function (candidate) {
      return sameId(candidate.id, variantId);
    });

    if (!variant && planId) {
      variant = product.variants.find(function (candidate) {
        return (candidate.selling_plan_allocations || []).some(function (allocation) {
          return sameId(allocation.selling_plan_id, planId);
        });
      });
    }

    return variant || product.variants[0] || null;
  }

  function selectedAllocation(variant, planId) {
    if (!variant || !Array.isArray(variant.selling_plan_allocations)) return null;
    return variant.selling_plan_allocations.find(function (allocation) {
      return sameId(allocation.selling_plan_id, planId);
    }) || null;
  }

  function formatGBP(cents) {
    if (!Number.isFinite(Number(cents))) return '';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(Number(cents) / 100);
  }

  function discountPercent(allocation, product, planId) {
    var price = Number(allocation && allocation.price);
    var compareAt = Number(allocation && allocation.compare_at_price);

    if (price > 0 && compareAt > price) {
      return Math.round((1 - price / compareAt) * 100);
    }

    var groups = (product && product.selling_plan_groups) || [];
    for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
      var plans = groups[groupIndex].selling_plans || [];
      for (var planIndex = 0; planIndex < plans.length; planIndex += 1) {
        var plan = plans[planIndex];
        if (!sameId(plan.id, planId)) continue;
        var adjustment = plan.price_adjustments && plan.price_adjustments[0];
        if (adjustment && adjustment.value_type === 'percentage') {
          return Math.round(Number(adjustment.value));
        }
      }
    }

    return 0;
  }

  function addBenefit(list, strongText, trailingText) {
    var item = document.createElement('li');
    var mark = document.createElement('span');
    var copy = document.createElement('span');
    var strong = document.createElement('strong');

    mark.className = 'awkn-seal-benefit__mark';
    mark.setAttribute('aria-hidden', 'true');
    mark.textContent = '✓';
    strong.textContent = strongText;
    copy.appendChild(strong);
    if (trailingText) copy.appendChild(document.createTextNode(trailingText));
    item.appendChild(mark);
    item.appendChild(copy);
    list.appendChild(item);
  }

  function ensureBenefits(labelContainer) {
    var list = labelContainer.querySelector('.awkn-seal-benefits');
    if (list) return list;

    list = document.createElement('ul');
    list.className = 'awkn-seal-benefits';
    list.setAttribute('aria-label', 'Subscription benefits');
    addBenefit(list, '30 day money back guarantee', '');
    addBenefit(list, 'Free UK delivery', ' on every order');
    addBenefit(list, 'Edit, skip or cancel', ' any time after your 2nd order');
    labelContainer.appendChild(list);
    return list;
  }

  function ensureGift(labelContainer) {
    var gift = labelContainer.querySelector('.awkn-seal-gift');
    if (gift) return gift;

    gift = document.createElement('div');
    gift.className = 'awkn-seal-gift';

    var image = document.createElement('img');
    image.className = 'awkn-seal-gift__image';
    image.alt = 'AWKN Night Owl with Korean soju shot glasses';
    image.loading = 'lazy';
    image.width = 52;
    image.height = 52;
    if (CONFIG.giftImageUrl) image.src = CONFIG.giftImageUrl;

    var copy = document.createElement('div');
    copy.className = 'awkn-seal-gift__copy';

    var badge = document.createElement('span');
    badge.className = 'awkn-seal-gift__badge';
    badge.textContent = 'FREE';

    var text = document.createElement('span');
    var strong = document.createElement('strong');
    strong.textContent = 'Shot Glasses (worth £10.99)';
    text.appendChild(strong);
    text.appendChild(document.createTextNode(' gift with first order'));

    copy.appendChild(badge);
    copy.appendChild(text);
    gift.appendChild(image);
    gift.appendChild(copy);
    labelContainer.appendChild(gift);
    return gift;
  }

  function ensureDiscount(priceContainer) {
    var discount = priceContainer.querySelector('.awkn-seal-discount');
    if (discount) return discount;

    discount = document.createElement('span');
    discount.className = 'awkn-seal-discount';
    priceContainer.insertBefore(discount, priceContainer.firstChild);
    return discount;
  }

  function ensurePerServing(firstLine) {
    var perServing = firstLine.querySelector('.awkn-seal-per-serving');
    if (perServing) return perServing;

    perServing = document.createElement('span');
    perServing.className = 'awkn-seal-per-serving';
    firstLine.appendChild(perServing);
    return perServing;
  }

  function updateFrequencyCopy(target) {
    target.querySelectorAll('.sls-select[name="subs_interval"] option').forEach(function (option) {
      var normalized = option.textContent.replace(/\s*\(Most popular\)\s*/i, '').trim();
      var nextText = /^2\s*weeks?$/i.test(normalized) ? '2 weeks (Most popular)' : normalized;
      if (option.textContent !== nextText) option.textContent = nextText;
    });

    target.querySelectorAll('.sls-selling-plan-group-first-option').forEach(function (label) {
      var normalized = label.textContent.replace(/\s*\(Most popular\)\s*/i, '').trim();
      var nextText = /^2\s*weeks?$/i.test(normalized) ? '2 weeks (Most popular)' : normalized;
      if (label.textContent !== nextText) label.textContent = nextText;
    });
  }

  function customizeTarget(target) {
    var handle = target.getAttribute('data-handle');
    var settings = PRODUCTS[handle];
    var widget = target.querySelector('.sealsubs-container');
    if (!settings || !widget) return;

    target.setAttribute('data-awkn-seal-customized', 'true');
    widget.classList.add('awkn-seal-widget');
    if (CONFIG.arrowUrl) {
      target.style.setProperty('--awkn-seal-arrow', 'url(' + JSON.stringify(CONFIG.arrowUrl) + ')');
    }

    var heading = widget.querySelector('.sls-purchase-options-label');
    if (heading && heading.textContent.trim() !== 'Choose Your Plan') {
      heading.textContent = 'Choose Your Plan';
    }

    updateFrequencyCopy(target);

    var subscription = widget.querySelector('.sls-option-container[data-selling-plan-group]');
    if (!subscription) return;

    var labelContainer = subscription.querySelector('.sls-label-container');
    var firstLine = labelContainer && labelContainer.querySelector(':scope > .sls-selling-plan-group-first-line');
    var priceContainer = firstLine && firstLine.querySelector('.sls-selling-plan-group-price');
    if (!labelContainer || !firstLine || !priceContainer) return;

    var product = parseProduct(target);
    var planId = selectedPlanId(target);
    var variant = selectedVariant(target, product, planId);
    var allocation = selectedAllocation(variant, planId);
    var discount = ensureDiscount(priceContainer);
    var percent = discountPercent(allocation, product, planId);
    var discountText = percent > 0 ? '-' + percent + '%' : '';
    if (discount.textContent !== discountText) discount.textContent = discountText;
    discount.hidden = percent <= 0;

    var perServing = ensurePerServing(firstLine);
    if (allocation && Number(allocation.price) > 0) {
      var perServingText = formatGBP(Number(allocation.price) / settings.servings) + ' Per Serving';
      if (perServing.textContent !== perServingText) perServing.textContent = perServingText;
      perServing.hidden = false;
    } else {
      if (perServing.textContent) perServing.textContent = '';
      perServing.hidden = true;
    }

    ensureBenefits(labelContainer);
    var existingGift = labelContainer.querySelector('.awkn-seal-gift');
    if (settings.gift) {
      var gift = ensureGift(labelContainer);
      gift.hidden = false;
      var giftImage = gift.querySelector('.awkn-seal-gift__image');
      if (giftImage && CONFIG.giftImageUrl && giftImage.src !== CONFIG.giftImageUrl) {
        giftImage.src = CONFIG.giftImageUrl;
      }
    } else if (existingGift) {
      existingGift.remove();
    }
  }

  function customizeAll() {
    scheduled = false;
    document.querySelectorAll('.sealsubs-target-element[data-handle][data-product]').forEach(customizeTarget);
  }

  function scheduleCustomization() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(customizeAll);
  }

  function initialize() {
    customizeAll();

    var observer = new MutationObserver(scheduleCustomization);
    observer.observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('change', function (event) {
      if (event.target.closest('.sealsubs-target-element, [data-product-form], form[action*="/cart/add"]')) {
        window.setTimeout(scheduleCustomization, 0);
      }
    });

    ['variant:change', 'variant:changed', 'product:variant-change', 'shopify:section:load'].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleCustomization);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
